import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/woman.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiOutlineTwitter } from "react-icons/ai";
import { FaLinkedinIn, FaMediumM } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect</span> with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/JeninaAngelin"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/angelicajeni7"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/jenina-angelin/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              {/* Medium */}
              <li className="social-icons">
                <a
                  href="https://medium.com/@angelicajeni7"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="Medium"
                >
                  <FaMediumM />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple">INTRODUCE</span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with 🖥️ Software World in the era
              of Start &rarr; All Programs &rarr; Accessories…
              <br />
              <br />I am fluent in classics like{" "}
              <i>
                <b className="purple">Python, SQL, Git, and Linux.</b>
              </i>
              <br />
              <br />
              <b className="purple">Data</b> is the heart ❤️ of my tech skills. <br />
              I thrive in using Data for Insightful Analytics 📈, Deep Learning 🤖, and Securing Data 🔒.
              <br />
              <br />
              I develop projects focusing on {" "}
              <b className="purple">AI Product lifecycle</b>{" "} and 
              implementation of <b className="purple">Responsible AI</b>,
              following rigorous <b className="purple">Software Development 🧠 standards</b>.
              <br />
              <br />
              <b className="purple">Adaptability</b> is my superpower 🚀 and <b className="purple">Resilience</b> keeps me grounded 🛡️.
  <br/>I don’t back down from challenges. I quickly embrace change, whether
  it's a new tech stack, shifting project goals, or a sudden pivot.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
